import { withDefault } from '@vy/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useInvoicesOverviewsFromParamsNew } from '../../../hooks/requests/use-invoices-overviews/use-invoices-overviews-from-params-new';
import { useInvoicesHighlightsStatistics } from '../../../hooks/requests/use-invoices-highlights-statistics';
import { usePageFiltersPersistence } from '../../../hooks/use-page-filters-persistence';
import { InvoicesPageContentContainer } from '../containers/InvoicesPageContentContainer';
import { useExchangeRates } from '../../../hooks/requests/exchange-rates/use-exchange-rates';
import { useInvoicesPageParamsNew } from '../hooks/use-invoices-page-params-new';
import { INVOICES_QUERY_SEARCH_PARAM_KEY } from '../hooks/use-query-input-param-consts';

const INVOICES_PERSISTED_FILTER_PARAMS = ['filters', INVOICES_QUERY_SEARCH_PARAM_KEY] as const;

const InvoicesPage: React.FC = () => {
  const params = useInvoicesPageParamsNew();

  const {
    data: invoices,
    isFetching: isFetchingInvoicesOverviews,
    page,
    pageSize,
    onPageChange,
    onPageSizeChange,
  } = useInvoicesOverviewsFromParamsNew();

  const filters = params.filters?.map((filter) => {
    if ('id' in filter) {
      const { id: _id, ...rest } = filter;
      return rest;
    }
    return filter;
  });

  const { data: highlightsStatistics } = useInvoicesHighlightsStatistics({
    filters,
    search: params.search,
    issuedDates: params.issuedDates,
  });

  const { data: exchangeRates } = useExchangeRates();

  usePageFiltersPersistence(INVOICES_PERSISTED_FILTER_PARAMS);

  const invoicesOverviews = invoices?.invoicesOverviews ?? [];
  const availableCustomFieldNames = invoices?.availableCustomFieldNames;
  const invoicesHighlightsSummary = highlightsStatistics?.summary;

  return (
    <>
      <Helmet>
        <title>Invoices</title>
      </Helmet>

      <VyLayout>
        <InvoicesPageContentContainer
          invoices={invoicesOverviews}
          invoicesCount={withDefault(invoices?.count, 0)}
          loadingInvoices={isFetchingInvoicesOverviews}
          invoicesHighlightsSummary={invoicesHighlightsSummary}
          exchangeRates={exchangeRates}
          availableCustomFieldNames={availableCustomFieldNames}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </VyLayout>
    </>
  );
};

const invoicesPageWithGlobalSearchParams = withGlobalSearchParams(InvoicesPage);
const InvoicesPageWithSuspenseBoundary = withSuspenseBoundary(invoicesPageWithGlobalSearchParams);
export { InvoicesPageWithSuspenseBoundary as InvoicesPage };
